import { ReactNode } from 'react'
import { useFormContext } from 'react-hook-form'
import { CheckboxProps, FormControlLabel, FormHelperText, SxProps } from '@mui/material'

// Components
import { Controller } from 'react-hook-form'
import { Checkbox } from '@mui/material'

interface CheckboxControllerProps {
  name: string
  label: ReactNode
  sx?: SxProps
  size?: CheckboxProps['size']
  disabled?: boolean
  customOnChange?: () => void
}

const CheckboxController = ({ name, label, sx, size, disabled, customOnChange }: CheckboxControllerProps) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: props, fieldState: { error: { message } = {}, invalid } }) => (
        <>
          <FormControlLabel
            control={
              <Checkbox
                {...props}
                size={size}
                checked={props.value ?? false}
                disabled={disabled}
                onChange={event => {
                  customOnChange?.()
                  return props.onChange(event)
                }}
              />
            }
            label={label}
            sx={sx}
          />
          {invalid && message && (
            <FormHelperText sx={{ color: theme => theme.palette.error.main }}>{message}</FormHelperText>
          )}
        </>
      )}
    />
  )
}

export default CheckboxController
